var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"telstra-ui-vue-svg",class:_vm.className || 'tl-default-svg-class',attrs:{"xmlns":"http://www.w3.org/2000/svg"},on:{"click":_vm.click}},[_c('use',{attrs:{"xlink:href":_vm.icons + '#' + _vm.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }